import { useGetOptionsDefaultQuery } from 'services/options';
import { FindAllOptionsDefaultDto } from 'types';
import { skipToken } from '@reduxjs/toolkit/query';

type Props = Pick<FindAllOptionsDefaultDto, 'optionTypeId' | 'service'> & {
  skip?: boolean;
};

export function useOptionsDefault({ optionTypeId, service, skip }: Props) {
  const queryArgs = skip ? skipToken : { optionTypeId, service };

  const { data: optionsResponse, refetch, error, isLoading, isSuccess } = useGetOptionsDefaultQuery(queryArgs);

  return {
    optionsDefault: optionsResponse?.data,
    refetch,
    isSuccess,
    isLoading,
    error
  };
}
